import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function CommonTooltip({
  id,
  children,
  title,
}: {
  id: string;
  children: React.ReactNode;
  title: string;
}) {
  return (
    <OverlayTrigger
      overlay={<Tooltip id={id}>{title}</Tooltip>}
      placement="top"
    >
      <span style={{ cursor: 'pointer' }}>{children}</span>
    </OverlayTrigger>
  );
}
